<script setup lang="ts">
import KlereoModal from "@/shared/components/KlereoModal.vue";
import { ref } from "vue";
import KlereoCaptcha from "@/shared/components/KlereoCaptcha.vue";
import { apiService } from "@/services/services";
import LoadingOverlay from "@/shared/components/LoadingOverlay.vue";
import { useRouter } from "vue-router";

const modalState = ref<"closed" | "confirmation" | "form">("closed");
const captchaSeed = ref(0);

const loading = ref(false);
const error = ref<any>(null);
const router = useRouter();

const onSubmit = async (values: { pass: string; captcha: string }) => {
  loading.value = true;
  error.value = null;
  await apiService
    .deleteUser(values)
    .then(
      () => {
        setTimeout(() => router.push("/logout"), 1000);
      },
      (err) => {
        error.value = err;
        captchaSeed.value++;
      }
    )
    .finally(() => (loading.value = false));
};
</script>

<template>
  <button class="btn bg-red-500" @click="modalState = 'confirmation'">
    {{ $t("DeleteAccountButton") }}
  </button>

  <klereo-modal
    :opened="modalState !== 'closed'"
    @close="modalState = 'closed'"
    class="text-left"
  >
    <loading-overlay :loading="loading" :error="error" />
    <div class="font-medium text-lg mb-3">{{ $t("DeleteAccountTitle") }}</div>

    <div>
      <div v-if="modalState === 'confirmation'">
        <div class="text-gray-200 text-left text-sm my-3">
          {{ $t("DeleteAccountConfirmationText") }}
        </div>
        <div v-if="modalState === 'confirmation'" class="flex justify-end">
          <div class="btn btn--secondary" @click="modalState = 'closed'">
            {{ $t("Abort") }}
          </div>
          <div class="btn btn--danger" @click="modalState = 'form'">
            {{ $t("Valid") }}
          </div>
        </div>
      </div>

      <div v-if="modalState === 'form'" class="form-small">
        <div class="text-gray-200 text-left text-sm my-3">
          {{ $t("DeleteAccountEnterPasswordPrompt") }}
        </div>
        <div>
          <FormKit
            id="deleteAccount"
            type="form"
            @submit="onSubmit"
            :actions="false"
            #default="{ state: { valid } }"
            validation-visibility="blur"
          >
            <FormKit
              name="pass"
              outer-class="mb-4"
              type="password"
              :label="$t('Pass')"
              validation="required"
            />

            <klereo-captcha :refresh="captchaSeed" />
            <FormKit
              name="captcha"
              outer-class="mb-4"
              type="password"
              validation="required"
              :label="$t('EnterSecur')"
            />

            <div class="flex justify-end">
              <div class="btn btn--secondary" @click="modalState = 'closed'">
                {{ $t("Abort") }}
              </div>
              <button
                class="btn btn--danger"
                @click="modalState = 'form'"
                :disabled="!valid"
              >
                {{ $t("DeleteAccountButton") }}
              </button>
            </div>
          </FormKit>
        </div>
      </div>
    </div>

    <div v-if="modalState === 'form'"></div>
  </klereo-modal>
</template>
